import React from 'react'

import { ImageNumberTitleDescriptionItem } from '@application/Interfaces/Features/ImageNumberTitleDescription/ImageNumberTitleDescriptionItem/ImageNumberTitleDescriptionItem'
import { ImageNumberTitleDescriptionType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { Carousel } from '@organisms/Carousel'
import { TitleSection } from '@organisms/TitleSection'

export const ImageNumberTitleDescription = ({
    imageNumberTitleDescriptionTitle,
    imageNumberComponentDescription,
    subtitle,
    boxes,
}: ImageNumberTitleDescriptionType): JSX.Element => {
    return (
        <TitleSection
            title={imageNumberTitleDescriptionTitle}
            subtitle={subtitle}
            description={imageNumberComponentDescription}
        >
            <Grid container>
                <Carousel>
                    {boxes.map((box) => (
                        <ImageNumberTitleDescriptionItem {...box} key={box.title} />
                    ))}
                </Carousel>
            </Grid>
        </TitleSection>
    )
}
